import max from 'lodash/max';
export const _max = max;
